import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApiService } from '../../services/api/api-service';

export const AuthGuard: CanActivateFn = (route, state) => {

  const authService = inject(ApiService);
  const router = inject(Router);

  const isLoggedIn = authService.isAuthenticated();

  if (!isLoggedIn) {
    return router.parseUrl('/auth/login');
  }

  return true;
};
